import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-33e8dfd8")
const _hoisted_1 = { class: "my-page-container" }
const _hoisted_2 = { class: "farmer-wrap" }
const _hoisted_3 = { class: "farmer-info" }
const _hoisted_4 = {
  key: 1,
  class: "icons-font left",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-nongmin2" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "phone" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "bottom-tag" }
const _hoisted_12 = { class: "farmer-bottom" }
const _hoisted_13 = { class: "user-bottom" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userData.headImg)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "left",
              src: _ctx.userData.headImg
            }, null, 8, ["src"]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userData.farmerName), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.userData.phoneNumber), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userData.addressInfo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.types, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              style: _normalizeStyle('background:' + item.color),
              key: item.id
            }, _toDisplayString(item.name), 5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_van_cell, {
        onClick: _ctx.onResource,
        title: "我的资源",
        "is-link": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_van_cell, {
        onClick: _ctx.onFeedback,
        title: "吐个槽",
        "is-link": ""
      }, null, 8, ["onClick"])
    ])
  ]))
}